import styled from "styled-components";

export const Secondary = styled.div`
	${({ theme }) => theme.textStyles.secondary};
`;

export const Tertiary = styled.div`
	${({ theme }) => theme.textStyles.tertiary};
`;
